/* jshint esversion:6 */
import * as API from '@/endpoints'
import VueCookie from 'vue-cookie'
import Axios from 'axios'
import Vue from 'vue'
import axiosRetry from 'axios-retry';

axiosRetry(Axios, { retries: 0 });

export default {
    namespaced: true,
    state: {
      feature: {
        data: [],
        isLoading: false
      },
      discover: {
        data: [],
        isLoading: false
      },
      extra: {
        data: [],
        isLoading: false
      }
    },
    mutations: {
      setFeaturedData(state, v) {
        Vue.set(state.feature, 'data', v);
      },
      setFeaturedLoader(state, v) {
        Vue.set(state.feature, 'isLoading', v);
      },
      setDiscoverData(state, v) {
        Vue.set(state.discover, 'data', v);
      },
      setDiscoverLoader(state, v) {
        Vue.set(state.discover, 'isLoading', v);
      },
      setExtraData(state, v) {
        Vue.set(state.extra, 'data', v);
      },
      setExtraLoader(state, v) {
        Vue.set(state.extra, 'isLoading', v);
      },
      addNewFeature(state, v) {
        let foundInStack = state.feature.data.find( (i) => {
          return i.id === v.id
        });

        if( !foundInStack ) state.feature.data.unshift(v);
      },
      removeFeature(state, v) {
        let foundInStack = state.feature.data.findIndex( (i) => {
          return i.id === v.id
        });
        if(foundInStack != -1){
          state.feature.data.splice(foundInStack,1);
        }
      },
    },
    actions: {
      getFeaturedActivity({rootState, commit, dispatch}) {
        if( !localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE') ) return false;

        return new Promise((resolve, reject) => {
          commit('setFeaturedLoader', true);
          Axios.get(API.endpoints.base + 'feed/activity/feature?brand_id='+Cons[0].BRAND_ID, {
            'axios-retry': {
              retries: 3
            }
          })
            .then((res) => {
              commit('setFeaturedData', res.data);
              commit('setFeaturedLoader', false);
              resolve(res.data);
            })
            .catch(_err => {
              dispatch('exceptionHandling', { _err }, { root: 1 })
              commit('setFeaturedLoader', false);
              reject(_err)
            });       
        })
      },
      getDiscoverFeaturedActivity({commit, dispatch}, {id}) {
        return new Promise((resolve, reject) => {
          commit('setDiscoverLoader', true);
          Axios.get(API.endpoints.careplan + '/' + id + '/item?filter=is_featured:1')
            .then((res) => {
              commit('setDiscoverData', res.data);
              commit('setDiscoverLoader', false);
              resolve(res.data);
            })
            .catch(_err => {
              dispatch('exceptionHandling', { _err }, { root: 1 })
              commit('setDiscoverLoader', false);
              reject(_err)
            });
        })
      },
      getExtraFeaturedActivity({commit, dispatch}, {id}) {
        return new Promise((resolve, reject) => {
          commit('setExtraLoader', true);
          Axios.get(API.endpoints.careplan + '/' + id + '/item?filter=is_featured:1')
            .then((res) => {
              commit('setExtraData', res.data);
              commit('setExtraLoader', false);
              resolve(res.data);
            })
            .catch(_err => {
              dispatch('exceptionHandling', { _err }, { root: 1 })
              commit('setExtraLoader', false);
              reject(_err)
            });
        })
      }
    }
}
